import createAction from 'Store/utils/createAction';
import { SET_DATA_SCORE } from 'Store/lead-info/constants';

const setDataScore = (score: string) => {
  return createAction(SET_DATA_SCORE, {
    score,
  });
};

export { setDataScore };
